var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("textarea", {
    directives: [
      { name: "model", rawName: "v-model", value: _vm.text, expression: "text" }
    ],
    ref: "input",
    class: _vm.computedClasses,
    attrs: { rows: _vm.inputRows },
    domProps: { value: _vm.text },
    on: {
      focus: _vm.handleFocus,
      blur: _vm.handleBlur,
      input: function($event) {
        if ($event.target.composing) {
          return
        }
        _vm.text = $event.target.value
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }